@if (valueLabels.include.length === 0 && valueLabels.exclude.length === 0 && !valueLabels.includeAll) {
    <p>
        {{ 'all' | localize }}
    </p>
}

@if (valueLabels?.includeAll.length > 0) {
    @for (includeAll of valueLabels.includeAll; track includeAll; let last = $last) {
        {{ includeAll | localize }}
        @if (!last) {
            <span class="agpr-operator">
                {{ 'Monitoring.searchCriteria.and' | localize }}
            </span>
        }
    }
    <br>
}

@if (valueLabels?.includeAll.length > 0 && (valueLabels.include.length > 0 || valueLabels.exclude.length > 0)) {
    <span class="agpr-operator">
        {{ 'Monitoring.searchCriteria.and' | localize | uppercase }}
    </span>
}

@if (valueLabels.include.length > 0) {
    @if (valueLabels.include.length > 1 && (valueLabels?.includeAll.length > 0 || valueLabels.exclude.length > 0)) {
        <span> {{ "(" }} </span>
    }
    
    @for (include of valueLabels.include; track include; let last = $last) {
        {{ include | localize }}
        @if (!last) {
            <span class="agpr-operator">
                {{ 'Monitoring.searchCriteria.or' | localize }}
            </span>
        }
    }
    
    @if (valueLabels.include.length > 1 && (valueLabels?.includeAll.length > 0 || valueLabels.exclude.length > 0)) {
        <span>{{ ")" }}</span>
    }
    
    <br>
}

@if (valueLabels.include.length > 0 && valueLabels.exclude.length > 0) {
    <span class="agpr-operator">
        {{ 'Monitoring.searchCriteria.and' | localize | uppercase }}
    </span>
}

@if (valueLabels.exclude.length > 0) {
    <span class="agpr-operator">
        {{ 'Monitoring.searchCriteria.not' | localize | uppercase }}
    </span>

    @if (valueLabels.exclude.length > 1 && (valueLabels.include.length > 0 || valueLabels?.includeAll.length > 0)) {
        <span>{{ "(" }}</span>
    }
    
    @for (exclude of valueLabels.exclude; track exclude; let last = $last) {
        {{ exclude | localize }}
        @if (!last) {
            <span class="agpr-operator">
                {{ 'Monitoring.searchCriteria.or' | localize }}
            </span>
        }
    }

    @if (valueLabels.exclude.length > 1 && (valueLabels.include.length > 0 || valueLabels?.includeAll.length > 0)) {
        <span>{{ ")" }}</span>
    }
}
